import { render, staticRenderFns } from "./EliminarCuenta.vue?vue&type=template&id=e4b80e18&scoped=true&"
import script from "./EliminarCuenta.vue?vue&type=script&lang=ts&"
export * from "./EliminarCuenta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b80e18",
  null
  
)

export default component.exports